"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _contentConverter = require("@insided/shared/uikit/Editor/contentConverter");

var quoteBoxPlugin = {
  requires: 'widget',
  icons: 'simplebox',
  init: function init(editor) {
    editor.addCommand('quote-user', {
      editorFocus: true,
      exec: function exec(editor, data) {
        var parser = new DOMParser();
        var content = parser.parseFromString(data.data, 'text/html');
        content.querySelectorAll('.widget-toc').forEach(function (e) {
          return e.remove();
        });
        editor.insertHtml((0, _contentConverter.toEditorFormat)("<content-quote data-username=\"".concat(data.user, "\">").concat(content.body.innerHTML, "</content-quote><p></p>")));
        return true;
      }
    });

    function isElement(node) {
      return 'is' in node;
    }

    editor.on('key', function (evt) {
      if (evt.data.keyCode !== 13) return; // get element that's in focus

      var range = editor.getSelection().getRanges()[0];
      var startOfBlock = range.checkStartOfBlock();
      var endOfBlock = range.checkEndOfBlock();
      var path = editor.elementPath(range.startContainer);
      var paragraphBlock = path.block;
      if (!paragraphBlock) return; // are we inside an empty paragraph and parent element is a user quote

      var parentIsQuoteContent = paragraphBlock.getParent().hasClass('content-quote-content');
      var contentQuoteRoot = paragraphBlock.getParent().getParent();
      var contentQuoteWidgetElement = contentQuoteRoot.getParent();
      var parentUsernameElement = contentQuoteRoot.findOne('.content-quote-username');
      var quotedUsername = contentQuoteRoot.getAttribute('data-username');
      if (!startOfBlock || !endOfBlock || !parentIsQuoteContent) return;
      evt.cancel(); // collect all elements after the currently focused one

      var list = [];
      var block = paragraphBlock.getNext();
      paragraphBlock.remove();

      while (block) {
        list.push(block);
        block = block.getNext();
      } // there's only empty elements after current one -> just exit the quote


      if (!list.filter(function (element) {
        return !isElement(element) || element.getText().trim() !== '';
      }).length) {
        // eslint-disable-next-line new-cap
        var _newParagraph = new CKEDITOR.dom.element('p');

        _newParagraph.insertAfter(contentQuoteWidgetElement);

        range.moveToElementEditStart(_newParagraph);
        range.select();
        return;
      } // create a new quote


      var newQuote = CKEDITOR.dom.element.createFromHtml("<content-quote data-username=\"".concat(quotedUsername, "\">\n        <div class=\"content-quote-content\"></div>\n        </content-quote>\n"));
      newQuote.append(parentUsernameElement.clone(true, false), true); // will new quote element with the elements from the previous one

      var newQuoteContent = newQuote.getLast(function (node) {
        return isElement(node);
      });

      if (isElement(newQuoteContent)) {
        list.forEach(function (block) {
          return block.appendTo(newQuoteContent);
        });
      }

      newQuote.insertAfter(contentQuoteWidgetElement); // eslint-disable-next-line new-cap

      var newParagraph = new CKEDITOR.dom.element('p');
      newParagraph.insertAfter(contentQuoteWidgetElement);
      range.moveToElementEditStart(newParagraph);
      range.select();
      editor.widgets.initOn(newQuote, 'quote');
    });
    editor.widgets.add('quote', {
      button: 'Quote box',
      requiredContent: 'content-quote',
      editables: {
        content: '.content-quote-content'
      },
      upcast: function upcast(elem, data) {
        var is = elem.name === 'content-quote';

        if (is) {
          data.user = elem.attributes['data-username'];
        }

        return is;
      }
    });
  }
};
var _default = quoteBoxPlugin;
exports.default = _default;